import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPageContent, updateCurrentScreen } from "../../utils";
import { useAuth } from "../../hooks/useAuth";
import {
    selectApplicationInstructionData,
    selectApplicationInstructionStatus,
    selectApplicationInstructionError,
    initializeAsync,
} from "./applicationInstructionSlice";

import { Button, Container, Typography, Card, CardContent, Box } from "@mui/material";

import { useNavigate } from "react-router-dom";
import { InlineText } from "../../components/InlineText";
import { ReactComponent as CurrancyIcon } from "../../assets/svgs/currencyCyan.svg";
import { ReactComponent as ThunbDownIcon } from "../../assets/svgs/thunb-down.svg";
import BadgeIcon from "@mui/icons-material/Badge";
import CheckIcon from "@mui/icons-material/Check";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import "./style.css";
import { DesktopHeader } from "../../components/DesktopHeader";
import { useMediaQuery } from "react-responsive";

const ApplicationInstruction = () => {
    const data = useSelector(selectApplicationInstructionData);
    const status = useSelector(selectApplicationInstructionStatus);
    const error = useSelector(selectApplicationInstructionError);
    const { getUserDetailsNotAsync, setUserDetailsNotAsync } = useAuth();
    let userDetails = getUserDetailsNotAsync();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isDesktop = useMediaQuery({ minWidth: 1180 });

    // Add Variables

    useEffect(() => {
        if (status === "idle") {
            dispatch(initializeAsync());
        }
    }, [status, dispatch]);

    const handleStartInstructionClick = () => {
        userDetails.applicant.currentScreen = "application-method";
        setUserDetailsNotAsync(userDetails);
        updateCurrentScreen(userDetails, "application-method", "");
        navigate("/application-method", {});
    };

    let body = (
        <>
            {" "}
            <>
                <Container className="ApplicationInstruction">
                    <Typography variant="h1" component="h1">
                        Here's what to expect
                    </Typography>
                    {/* {isDesktop && <DesktopHeader applicant={userDetails.applicant}></DesktopHeader>} */}
                    <Card sx={{ width: "100%" }}>
                        <CardContent>
                            <InlineText
                                sx={{ mt: "10px" }}
                                text={
                                    <Typography variant="h6" component="h6">
                                        <b>Verify your identity with valid ID</b>
                                    </Typography>
                                }
                                icon={
                                    <BadgeIcon
                                        style={{
                                            width: "16px",
                                        }}
                                    ></BadgeIcon>
                                }
                            ></InlineText>

                            <InlineText
                                sx={{ mt: "10px" }}
                                text={
                                    <Typography variant="h6" component="h6">
                                        <b>Verify your income</b>
                                    </Typography>
                                }
                                icon={<CurrancyIcon style={{ width: "16px" }}></CurrancyIcon>}
                            ></InlineText>

                            <InlineText
                                sx={{ mt: "10px", ml: "10px" }}
                                text={
                                    <Typography variant="h6" component="h6">
                                        With Plaid (recommended)
                                    </Typography>
                                }
                                icon={<CheckIcon style={{ width: "16px" }}></CheckIcon>}
                            ></InlineText>
                            <InlineText
                                sx={{ mt: "10px", ml: "10px" }}
                                text={
                                    <Typography variant="h6" component="h6">
                                        AND/OR upload your income documents (ie tax returns, pay stubs, bank statements,
                                        etc...)
                                    </Typography>
                                }
                                icon={<CheckIcon style={{ width: "16px" }}></CheckIcon>}
                            ></InlineText>
                            <InlineText
                                sx={{ mt: "2rem" }}
                                text={
                                    <Typography variant="h6" component="h6">
                                        <b>We'll use your personal infomation to...</b>
                                    </Typography>
                                }
                                icon={<InfoOutlinedIcon style={{ width: "16px" }}></InfoOutlinedIcon>}
                            ></InlineText>

                            <InlineText
                                sx={{ mt: "10px", ml: "10px" }}
                                text={
                                    <Typography variant="h6" component="h6">
                                        Check your credit score
                                    </Typography>
                                }
                                icon={<CheckIcon style={{ width: "16px" }}></CheckIcon>}
                            ></InlineText>
                            <InlineText
                                sx={{ mt: "10px", ml: "10px" }}
                                text={
                                    <Typography variant="h6" component="h6">
                                        Do a background check
                                    </Typography>
                                }
                                icon={<CheckIcon style={{ width: "16px" }}></CheckIcon>}
                            ></InlineText>
                            <InlineText
                                sx={{ mt: "10px", ml: "10px" }}
                                text={
                                    <Typography variant="h6" component="h6">
                                        Check your residential and employment history
                                    </Typography>
                                }
                                icon={<CheckIcon style={{ width: "16px" }}></CheckIcon>}
                            ></InlineText>
                        </CardContent>
                    </Card>

                    <Button
                        onClick={handleStartInstructionClick}
                        color="primary"
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ height: "45px" }}
                    >
                        Continue
                    </Button>
                </Container>
            </>
        </>
    );

    return getPageContent(body, status, error);
};

export { ApplicationInstruction };
